<input type="text" [(ngModel)]="barcode" id="barcodeInput" class="barcode-input" />
